import { translations } from 'gipsy-misc'

export const taskListIntroductionPopupContent = {
  title: translations.onboarding.tasksListIntroduction.title,
  message: translations.onboarding.tasksListIntroduction.text,
  button: translations.onboarding.tasksListIntroduction.buttonText,
  action: 'onClose'
}



// WEBPACK FOOTER //
// ./src/features/onboarding/index.js